<script setup>
import { defineProps, ref, computed } from 'vue';
import { use18n } from '../../../../utils/v2_helper/common';

const { $t, $pid } = use18n();

const MAP = {
  PROMO_GWP: (p) => `${$t('home.giftTitle', { v1: p.giftProductName })}`,
  PROMO_PROD_PERCENT: (p) =>
    $t('home.fixAmountTitle', { v1: `${+p.percentageAmount}%` }),
  PROMO_PROD_AMOUNT: (p) =>
    $t('home.fixAmountTitle', { v1: $pid(p.fixAmount) }),
};

const props = defineProps({
  disable: { type: Boolean },
  vo: { type: Object, default: () => ({}) },
});
const vo = computed(() => props.vo);
</script>

<template>
  <section class="item" @click="!props.disable && $emit('onClick')">
    <div class="item-info">
      <div bold dot2 class="item-info-tile">
        {{ MAP[vo.voucherType]?.(vo) }} ({{ vo.voucherCode }})
      </div>
      <div class="item-info-subtile">
        {{ $t('checkout.minTransaction') }}
        {{ $pid(vo.minimumAmount || 0) }}
      </div>
    </div>
    <i v-if="!disable" class="item-icon iconfont dm-right" />
  </section>
</template>
<style scoped lang="scss">
.item {
  display: flex;
  padding: 24px 20px;
  background: #fff;
  align-items: center;
  border-radius: 8px;
  & + & {
    margin-top: 8px;
  }
  .item-info {
    display: flex;
    flex-direction: column;
    &-tile {
      margin-bottom: 3px;
    }
  }
  .item-icon {
    padding: 10px 10px;
    margin-left: auto;
  }
}
</style>
